export enum NotificationTypeEnum {
  Success = 'success',
  Error = 'error',
  Info = 'info'
}
